/**
 * Product Gallery Web Component
 * Handles thumbnail clicks to swap main image and click-to-zoom via native <dialog>.
 * Uses event delegation — single click listener on component root.
 */
import { ABBaseComponent, defineComponent } from './ab-base-component.js';

class ABProductGallery extends ABBaseComponent {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    // Thumbnail click — swap main image
    const thumbnail = event.target.closest('.ab-product__thumbnail');
    if (thumbnail) {
      event.preventDefault();
      const mediaId = thumbnail.dataset.mediaId;
      this.setActiveMedia(mediaId, thumbnail);
      return;
    }

    // Main image click — open zoom dialog
    const zoomTarget = event.target.closest('[data-zoom-target]');
    if (zoomTarget) {
      const dialog = this.$('.ab-product__zoom-dialog');
      if (dialog) {
        // Set zoom image src to full-resolution version
        const mainImg = this.$('.ab-product__gallery-main img');
        const zoomImg = dialog.querySelector('img');
        if (mainImg && zoomImg) {
          zoomImg.src = mainImg.src.replace(/width=\d+/, 'width=1200');
          zoomImg.alt = mainImg.alt;
        }
        dialog.showModal();
      }
      return;
    }

    // Dialog close button
    const closeBtn = event.target.closest('.ab-product__zoom-close');
    if (closeBtn) {
      const dialog = this.$('.ab-product__zoom-dialog');
      if (dialog) dialog.close();
      return;
    }

    // Dialog backdrop click to close
    const dialog = event.target.closest('dialog');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  }

  setActiveMedia(mediaId, clickedThumb) {
    // Update active thumbnail
    this.$$('.ab-product__thumbnail').forEach(thumb => {
      thumb.classList.toggle('active', thumb.dataset.mediaId === mediaId);
    });

    // Update main image — use the thumbnail's img src scaled up to gallery size
    const thumbImg = clickedThumb.querySelector('img');
    const mainImg = this.$('.ab-product__gallery-main img');
    if (thumbImg && mainImg) {
      const galleryUrl = thumbImg.src.replace(/width=\d+/, 'width=800');
      mainImg.src = galleryUrl;
      mainImg.srcset = ''; // Clear srcset to force src usage
    }
  }
}

defineComponent('ab-product-gallery', ABProductGallery);
